module.exports = __webpack_public_path__ + "img/bit_withdraw_icon.13ec0aee.svg";